import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { useContext } from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { WarningSeverityContext } from 'utilities/weather-warnings/context/context-warning-severity.js';
import { MarineWarningsContainer } from './marine-warnings-container.js';

export interface IWarningTileConfig extends IModuleConfig {
  category: string;
  noDataMessage: string;
}

export const WarningsTileModule = ({ config, isDrawer, modulePath }: IModule<IWarningTileConfig>) => {
  const { setWarningSeverity } = useContext(WarningSeverityContext);
  const { category, noDataMessage, title } = config;

  return (
    <Tile key={`${category}-${title}`} dataModule="warnings-tile marine-warnings" config={config}>
      <div data-module="warnings-tile marine-warnings" className="Tile-body">
        <TileBodyHeaderV2 isDrawer={isDrawer} modulePath={modulePath} config={config} classes="u-mB-responsive" />
        <MarineWarningsContainer
          category={category}
          noDataMessage={noDataMessage}
          setWarningSeverity={setWarningSeverity}
        />
      </div>
    </Tile>
  );
};
